<template>
  <div>
    <div class="section mb-3">
      <div class="section_header">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Endereço de falecimento
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="box_body px-3 py-2 mb-3">
      <div class="row no-gutters align-items-center">
        <div class="d-inline-flex box_body_content">
          <div class="d-inline-block mr-5">
            <ul class="box_list">
              <li class="box_list_item box_list_title">
                Endereço completo
              </li>

              <li class="box_list_item">
                <strong>{{ tratarDados('endereco', arquivoEstruturado.local_falecimento.endereco_local_falecimento) }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="section mb-3">
      <div class="section_header">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Dados de falecimento
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row gx-4">
        <div class="col-md-3">
          <label class="text-muted mb-1">Nº declaração de Óbito</label>
          <p><b>{{ arquivoEstruturado.do || 'Não informado' }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Data de falecimento</label>
          <p><b>{{ tratarDados('dataFalecimento', arquivoEstruturado.data_falecimento) }}</b></p>
        </div>

        <div class="col-md-3">
          <label class="text-muted mb-1">Hora de falecimento</label>
          <p><b>{{ arquivoEstruturado.hora_falecimento || 'Não informado' }}</b></p>
        </div>
      </div>
    </div>

    <div class="box mb-4">
      <div class="box_header p-2">
        <h3 class="box_header_title">
          {{ arquivoEstruturado.local_falecimento.Nome_local_falecimento || 'Não informado' }}
        </h3>
      </div>

      <div class="box_body px-3 py-2">
        <div class="row no-gutters align-items-center">
          <div class="d-inline-flex box_body_content">
            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  Tipo de estabelecimento
                </li>

                <li class="box_list_item">
                  <strong>{{ arquivoEstruturado.local_falecimento.tipo_local_falecimento || 'Não informado' }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  Endereço
                </li>

                <li class="box_list_item">
                  <strong>{{ tratarDados('endereco', arquivoEstruturado.local_falecimento.endereco_local_falecimento) }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section mb-3">
      <div class="section_header">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Médico
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(medico, index) in arquivoEstruturado.medicos"
         :key="index"
         class="box mb-4">
      <div class="box_header p-2">
        <h3 class="box_header_title">
          {{ medico.nome || 'Não informado' }}
        </h3>
      </div>

      <div class="box_body px-3 py-2">
        <div class="row no-gutters align-items-center">
          <div class="d-inline-flex box_body_content">
            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  CRM
                </li>

                <li class="box_list_item">
                  <strong>{{ medico.crm || 'Não informado' }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  UF
                </li>

                <li class="box_list_item">
                  <strong>{{ medico.crm_uf || 'Não informado' }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section mb-3">
      <div class="section_header">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Causas de Óbito
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mb-2">
      <div class="row gx-4">
        <div class="col-md-12">
          <label class="text-muted mb-1">Causa da morte</label>
          <p><b>{{ tratarDados('causaMorte', arquivoEstruturado.causa_morte) }}</b></p>
        </div>
      </div>
    </div>

    <div class="section mb-3">
      <div class="section_header">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Sepultamento
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="box mb-4">
      <div class="box_header p-2">
        <h3 class="box_header_title">
          {{ arquivoEstruturado.local_sepultamento.nome_local_sepultamento || 'Não informado' }}
        </h3>
      </div>

      <div class="box_body px-3 py-2">
        <div class="row no-gutters align-items-center">
          <div class="d-inline-flex box_body_content">
            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  Cidade
                </li>

                <li class="box_list_item">
                  <strong>{{ arquivoEstruturado.local_sepultamento.cidade_local_sepultamento || 'Não informado' }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="box_list">
                <li class="box_list_item box_list_title">
                  UF
                </li>

                <li class="box_list_item">
                  <strong>{{ arquivoEstruturado.local_sepultamento.uf_local_sepultamento || 'Não informado' }}</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DadosObito',
    props: {
      arquivoEstruturado: {
        type: Object,
        default: null
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não informado'

        switch (tipo) {
        case 'endereco':
          return this.formatarEndereco(dado)
        
        case 'dataFalecimento':
          return this.formatarData(dado)
        
        case 'causaMorte':
          return this.formatarCausaMorte(dado)

        default:
          return dado
        }
      },
      formatarEndereco (endereco) {
        const cep = endereco.cep ? endereco.cep.replace(/(\d{5})(\d{3})/, '$1-$2') : null

        const enderecoFormatado = [
          `${endereco.logradouro || ''}${endereco.numero ? `, ${endereco.numero}` : ''}`,
          endereco.complemento,
          endereco.bairro,
          `${endereco.cidade || ''}${endereco.uf ? ` - ${endereco.uf}` : ''}`,
          cep
        ]

        return enderecoFormatado.filter(Boolean).join(', ')
      },
      formatarData (data) {
        return data.replace(/-/g, '/')
      },
      formatarCausaMorte (causas) {
        if (!causas || !causas.length) return 'Não informado'

        return causas
          .map(causa => Object.values(causa)[0])
          .join('; ')
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }

.box {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    border-right: 2px solid #DDDDDD;
    border-bottom: 2px solid #DDDDDD;
    border-radius: 0 0 8px 8px;
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>